import { InvoiceType } from '@/api/invoicing/schema'
import { atom } from 'jotai'

export const jobGenerateInvoiceAtom = atom<InvoiceType | null>(null)
export const invoiceSortByAtom = atom<string>('')
export const invoiceSortOrderAtom = atom<string>('')